export default function arrayMax(array) {
  return Math.max(...array);
}
